import { ExclamationIcon } from "@heroicons/react/outline";
import { useState } from "react";
import API from "../../../utils/helpers/API.helpers";
import { useDownloadFileEnh } from "../../../utils/hooks/useDownloadFileEnh";
import { Button } from "../Button/Button";
import SimpleOverlay from "../SimpleOverlay/SimpleOverlay";

export const DownloadLinkEnh = ({ endpoint, label }) => {
  const [showAlert, setShowAlert] = useState(false);

  const preDownload = () => {
    document.body.style.cursor = "wait";
  };

  const postDownload = () => {
    document.body.style.cursor = "default";
  };

  const onError = () => {
    document.body.style.cursor = "default";
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 5000);
  };

  const downloadFile = () => {
    return API.getFile({ endpoint: endpoint });
  };

  const { download } = useDownloadFileEnh({
    apiDefinition: downloadFile,
    preDownload: preDownload,
    postDownload: postDownload,
    onError: onError
  });

  return (
    <span className="w-full">
      <button onClick={download} className="text-blue-500 hover:underline">
        {label}
      </button>
      <SimpleOverlay
        title={"Oops!"}
        message={
          <div>
            Terjadi masalah saat men-download file ini. Hubungi administrator
            atau coba beberapa saat lagi.
          </div>
        }
        isOpen={showAlert}
        onClose={() => {
          setShowAlert(false);
        }}
        icon={
          <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full sm:mx-0 sm:h-10 sm:w-10">
            <ExclamationIcon stroke="red" aria-hidden="true" />
          </div>
        }
        buttons={
          <>
            <Button
              color="blue"
              onClick={() => {
                setShowAlert(false);
              }}
            >
              <span className="font-bold">Ok</span>
            </Button>
          </>
        }
      />
    </span>
  );
};
